import Vue from 'vue'
import Store from 'store'

import RelatedProduct from './RelatedProduct.vue'

const el = '.nti-component--related-product'
const DOM = document.querySelector(el)

const render = function(){
    if(DOM){
        new Vue({
            store: Store,
            el,
            components:{
                RelatedProduct
            },
            template: '<RelatedProduct />'
        })
    }
}

export default {
    render
}